import React from 'react';
import Lottie from 'react-lottie';
import './Personal_Loan_Lottie.css';
import * as animationData from './Personal_Loan_Lottie.json';

function Personal_Loan_Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='Personal_Loan_Lottie_icon'>
                <Lottie className="me-auto"
                    options={defaultOptions}
                />
            </div>
        </section>
    );
}
export default Personal_Loan_Lottie;